import {Component, inject, viewChild} from '@angular/core';
import {
  ButtonComponent,
  CheckboxComponent,
  InputComponent,
  InputContainerComponent,
  NewsletterSubscribeComponent, ToastService
} from "@components";
import {FileUploaderComponent} from "../../../components/forms/file-uploader/file-uploader.component";
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelContent } from "@angular/material/expansion";
import {BaseSignupPageComponent} from "../artist-home-page/artist-home-page.component";
import {AuthService} from "@api-services";
import {Router, RouterLink} from "@angular/router";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {Observable} from "rxjs";
import {SignupDto} from "@api-contracts";
import {TranslocoPipe} from "@jsverse/transloco";
import {environment} from "../../../../environments/environment";
import {LayoutService} from "@services";

@Component({
  selector: 'wun-gallery-home-page',
  standalone: true,
  imports: [
    ButtonComponent,
    CheckboxComponent,
    FileUploaderComponent,
    InputComponent,
    InputContainerComponent,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    NewsletterSubscribeComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslocoPipe,
    RouterLink,
    MatExpansionPanelContent
],
  templateUrl: './gallery-home-page.component.html',
  styleUrls: ['./gallery-home-page.component.scss', '../base-user-page/base-user-page.component.scss']
})
export class GalleryHomePageComponent extends BaseSignupPageComponent{
  layoutService = inject(LayoutService);
  authService = inject(AuthService);
  toastService = inject(ToastService);
  router = inject(Router);
  signupForm = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    confirmPassword: new FormControl('', [Validators.required]),
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    city: new FormControl('', [Validators.required]),
    country: new FormControl('', [Validators.required]),
    phone: new FormControl('', [Validators.required]),
    profileType: new FormControl<'ARTIST' | 'COLLECTOR' | 'GALLERY'>('GALLERY', [Validators.required]),
    businessName: new FormControl<string | null>(null),
    galleryName: new FormControl<string | null>(null),
    termsAndConditions: new FormControl(false, [Validators.requiredTrue]),
    socialMediaLinks: new FormControl<string | null>(null),
    numberOfArtistPortfolio: new FormControl('', [Validators.required]),
    artistsInPortfolio: new FormControl('', [Validators.required]),
    roleInGallery: new FormControl('none', [Validators.required]),
  }, {
    validators: [
      (form) => this.passwordMatchValidator(form)
    ]
  });
  fileUploader = viewChild.required<FileUploaderComponent>(FileUploaderComponent);

  constructor() {
    super();
    if (environment.env === 'local') {
      this.signupForm.setValue({
        username: 'artist1',
        password: 'Password123!',
        confirmPassword: 'Password123!',
        city: 'Rome',
        country: 'Italy',
        email: 'simonedisante@gmail.com',
        firstName: 'Simone',
        lastName: 'Disante',
        phone: '+391234567890',
        profileType: 'ARTIST',
        businessName: null,
        termsAndConditions: true,
        socialMediaLinks: 'https://instagram.com/simonedisante',
        roleInGallery: 'none',
        artistsInPortfolio: 'Giovanni',
        numberOfArtistPortfolio: '1',
        galleryName: 'My Gallery'
      })
    }
  }

  override validate() {
    return this.validatePdf(this.fileUploader())
  }

  preSignup(): Observable<(signupDto: SignupDto) => void> {
    return this.basePreSignup(this.fileUploader());
  }
}
